import Hero from './components/Hero'
import Footer from './components/Footer'
import './App.css';

function App() {
  return (
    <div className="App">
      <Hero />
      <Footer />
    </div>
  );
}

export default App;
